{
  let button = document.querySelector('.back-to-top');
  if (button) {
    // Toggle 'show' class based on scroll position
    jQuery(window).scroll(() => {
      window.scrollY > (window.innerHeight / 2) ? button.classList.add('show') : button.classList.remove('show');
    });

    // Smooth scroll to top and additional actions on click
    jQuery(button).click(() => {
      jQuery('html, body').animate({ scrollTop: 0 }, 650);

      setTimeout(() => {
        jQuery('#content').focus();
      }, 300);

      jQuery('.main-header').removeClass("hide compressed");
    });
  }
}
